// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Privacy_container__IgFvN{
    margin: 50px 20px;
}
.Privacy_subheader__rFs9z{
    margin-bottom: 10px;
    font-weight: 700;
}
.Privacy_paragraph__kD2zx{
    margin-bottom: 10px;
}
.Privacy_italicParagraph__T0Uy4{
    margin-bottom: 10px;
    font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/pages/Privacy.module.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;AACrB;AACA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,mBAAmB;AACvB;AACA;IACI,mBAAmB;IACnB,kBAAkB;AACtB","sourcesContent":[".container{\n    margin: 50px 20px;\n}\n.subheader{\n    margin-bottom: 10px;\n    font-weight: 700;\n}\n.paragraph{\n    margin-bottom: 10px;\n}\n.italicParagraph{\n    margin-bottom: 10px;\n    font-style: italic;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Privacy_container__IgFvN`,
	"subheader": `Privacy_subheader__rFs9z`,
	"paragraph": `Privacy_paragraph__kD2zx`,
	"italicParagraph": `Privacy_italicParagraph__T0Uy4`
};
export default ___CSS_LOADER_EXPORT___;
